import React, { ReactElement, ReactNode, useEffect, useState } from 'react';

interface ISuspense {
  children: ReactNode;
  fallback?: ReactElement | null;
}

const Suspense = ({ children, fallback }: ISuspense) => {
  const [hydrated, setHydrated] = useState(false);

  useEffect(() => {
    setHydrated(true);
  }, []);

  if (SSR || !hydrated) {
    return fallback || null;
  }

  return <React.Suspense fallback={fallback || null}>{children}</React.Suspense>;
};

export default Suspense;
